export class SelectedChildOrganizationInfo {
  organizationCd: string
  organizationName: string
  organizationTypeCd: string
  organizationTypeName: string
  children: SelectedChildOrganizationInfo[]
  childrenCustomer: any[]
}
